import { render } from "./ShortAnswer.vue?vue&type=template&id=37a6945a&scoped=true"
import script from "./ShortAnswer.vue?vue&type=script&lang=js"
export * from "./ShortAnswer.vue?vue&type=script&lang=js"

import "./ShortAnswer.vue?vue&type=style&index=0&id=37a6945a&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37a6945a"]])

export default __exports__